import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomFormComponent } from '@bo-client/activation-management/custom-form.component';
import { GridRegistrationModel } from '@bo-client/activation-management/grid-registration/model/grid-registration.model';
import { DataForCustomFormModel } from '@bo-client/activation-management/shared/models/actionWithMoreInfo.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-tr-sr-form',
  templateUrl: './tr-sr-form.component.html',
  styleUrls: ['./tr-sr-form.component.scss']
})
export class TrSrFormComponent
  implements CustomFormComponent<GridRegistrationModel, GridRegistrationModel>, OnInit
{
  @Input() data: DataForCustomFormModel<GridRegistrationModel>;
  @Output() onConfirm: EventEmitter<GridRegistrationModel> = new EventEmitter();

  public model: GridRegistrationModel;
  public currentForm: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.model = this.data.model;
    this.currentForm = this.fb.group({
      trId: [this.model.trId, Validators.required],
      srId: [this.model.srId, Validators.required]
    });
  }

  cancel() {
    this.onConfirm.emit(null);
  }

  confirm() {
    if (this.currentForm.valid) {
      this.model = {
        ...this.model,
        ...this.currentForm.value
      };
      this.onConfirm.emit(this.model);
    } else {
      this.currentForm.markAllAsTouched();
    }
  }
}
